// HKDSE 2015 Paper 1 Knowledge Graph Samples - Part 3
// Questions 11-15 from the complete LaTeX file

export const hkdse2015Samples_part3 = {
  polynomials: [
    {
      id: 'hkdse2015_polynomials_01',
      problem: "Let $f(x) = (x-2)^2(x+h) + k$, where $h$ and $k$ are constants. When $f(x)$ is divided by $x-2$, the remainder is $-5$. It is known that $f(x)$ is divisible by $x-3$. (a) Find $h$ and $k$. (b) Someone claims that all roots of the equation $f(x) = 0$ are integers. Do you agree? Explain your answer.",
      problemType: "polynomial_division_factors",
      difficulty: "harder",
      description: "Polynomial division and factorization",
      graphData: {
        nodes: [
          {
            id: "polynomial_structure",
            name: "Polynomial Structure",
            type: "concepts",
            description: "f(x) = (x-2)²(x+h) + k",
            value: "f(x) = (x-2)²(x+h) + k",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "remainder_theorem",
            name: "Remainder Theorem",
            type: "concepts",
            description: "When f(x) is divided by x-2, remainder is f(2)",
            value: "f(2) = -5",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "factor_theorem",
            name: "Factor Theorem",
            type: "concepts",
            description: "If x-3 is a factor, then f(3) = 0",
            value: "f(3) = 0",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step1_find_f2",
            name: "Step 1: Find f(2)",
            type: "steps",
            description: "Substitute x = 2 into f(x)",
            value: "f(2) = (2-2)²(2+h) + k = 0 + k = k = -5",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "step2_find_f3",
            name: "Step 2: Find f(3)",
            type: "steps",
            description: "Substitute x = 3 into f(x)",
            value: "f(3) = (3-2)²(3+h) + k = 1×(3+h) + (-5) = 3+h-5 = h-2 = 0",
            importance: 9,
            x: 0, y: 50, z: 0
          },
          {
            id: "step3_solve_h",
            name: "Step 3: Solve for h",
            type: "steps",
            description: "Solve h-2 = 0",
            value: "h = 2",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "step4_write_function",
            name: "Step 4: Write Function",
            type: "steps",
            description: "Write the complete function",
            value: "f(x) = (x-2)²(x+2) - 5 = (x-2)²(x+2) - 5",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_expand",
            name: "Part (b): Expand",
            type: "steps",
            description: "Expand f(x) to find roots",
            value: "f(x) = (x-2)²(x+2) - 5 = (x²-4x+4)(x+2) - 5",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_further_expand",
            name: "Part (b): Further Expand",
            type: "steps",
            description: "Continue expanding",
            value: "f(x) = x³ - 2x² - 4x + 8 - 5 = x³ - 2x² - 4x + 3",
            importance: 8,
            x: 0, y: 250, z: 0
          },
          {
            id: "part_b_find_roots",
            name: "Part (b): Find Roots",
            type: "steps",
            description: "Find roots of f(x) = 0",
            value: "x³ - 2x² - 4x + 3 = 0",
            importance: 9,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_b_test_roots",
            name: "Part (b): Test Roots",
            type: "steps",
            description: "Test possible integer roots",
            value: "x = 1: 1-2-4+3 = -2 ≠ 0, x = 3: 27-18-12+3 = 0 ✓",
            importance: 8,
            x: 0, y: 350, z: 0
          },
          {
            id: "part_b_conclusion",
            name: "Part (b): Conclusion",
            type: "steps",
            description: "Check if all roots are integers",
            value: "Not all roots are integers (complex roots exist)",
            importance: 9,
            x: 0, y: 400, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Values of h, k and conclusion",
            value: "(a) h = 2, k = -5 (b) No, not all roots are integers",
            importance: 10,
            x: 0, y: 450, z: 0
          }
        ],
        links: [
          { from: "polynomial_structure", to: "remainder_theorem", type: "enables", strength: 9 },
          { from: "polynomial_structure", to: "factor_theorem", type: "enables", strength: 9 },
          { from: "remainder_theorem", to: "step1_find_f2", type: "enables", strength: 9 },
          { from: "factor_theorem", to: "step2_find_f3", type: "enables", strength: 9 },
          { from: "step1_find_f2", to: "step2_find_f3", type: "enables", strength: 9 },
          { from: "step2_find_f3", to: "step3_solve_h", type: "leads to", strength: 8 },
          { from: "step3_solve_h", to: "step4_write_function", type: "leads to", strength: 9 },
          { from: "step4_write_function", to: "part_b_expand", type: "enables", strength: 8 },
          { from: "part_b_expand", to: "part_b_further_expand", type: "leads to", strength: 8 },
          { from: "part_b_further_expand", to: "part_b_find_roots", type: "leads to", strength: 9 },
          { from: "part_b_find_roots", to: "part_b_test_roots", type: "enables", strength: 8 },
          { from: "part_b_test_roots", to: "part_b_conclusion", type: "leads to", strength: 9 },
          { from: "step3_solve_h", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "step1_find_f2", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_b_conclusion", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  statistics: [
    {
      id: 'hkdse2015_statistics_01',
      problem: "The following stem-and-leaf diagram shows the distribution of body weights (in kg) of students in a football club. (a) Find the mean, median and range of the above distribution. (b) Two more students join the club. It is known that the mean and range of the weight distribution both increase by $1$ kg. Find the weight of each of these two students.",
      problemType: "statistics_stem_leaf",
      difficulty: "intermediate",
      description: "Statistical analysis of stem-and-leaf data",
      graphData: {
        nodes: [
          {
            id: "stem_leaf_data",
            name: "Stem-and-Leaf Data",
            type: "concepts",
            description: "Distribution of body weights",
            value: "40, 42, 43, 43, 43, 43, 49, 51, 51, 52, 52, 53, 57, 59, 63, 65, 68, 69, 78, 79",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_mean",
            name: "Part (a): Mean",
            type: "steps",
            description: "Calculate mean of the data",
            value: "Mean = (40+42+43+43+43+43+49+51+51+52+52+53+57+59+63+65+68+69+78+79)/20 = 56.5",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_median",
            name: "Part (a): Median",
            type: "steps",
            description: "Find median of the data",
            value: "Median = average of 10th and 11th values = (52+53)/2 = 52.5",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_a_range",
            name: "Part (a): Range",
            type: "steps",
            description: "Calculate range",
            value: "Range = 79 - 40 = 39",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_b_new_mean",
            name: "Part (b): New Mean",
            type: "steps",
            description: "New mean increases by 1",
            value: "New mean = 56.5 + 1 = 57.5",
            importance: 8,
            x: -200, y: 100, z: 0
          },
          {
            id: "part_b_new_range",
            name: "Part (b): New Range",
            type: "steps",
            description: "New range increases by 1",
            value: "New range = 39 + 1 = 40",
            importance: 8,
            x: 200, y: 100, z: 0
          },
          {
            id: "part_b_setup_equation",
            name: "Part (b): Setup Equation",
            type: "steps",
            description: "Set up equation for new mean",
            value: "(1130 + x + y)/22 = 57.5",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_range_condition",
            name: "Part (b): Range Condition",
            type: "steps",
            description: "Use range condition",
            value: "max(x,y) - min(40, min(x,y)) = 40",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_solve",
            name: "Part (b): Solve",
            type: "steps",
            description: "Solve the system",
            value: "x + y = 135, max(x,y) - min(x,y) = 40",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_final_weights",
            name: "Part (b): Final Weights",
            type: "steps",
            description: "Find the two weights",
            value: "x = 47.5, y = 87.5",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "All statistical measures and weights",
            value: "(a) Mean = 56.5, Median = 52.5, Range = 39 (b) 47.5 kg and 87.5 kg",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "stem_leaf_data", to: "part_a_mean", type: "enables", strength: 8 },
          { from: "stem_leaf_data", to: "part_a_median", type: "enables", strength: 8 },
          { from: "stem_leaf_data", to: "part_a_range", type: "enables", strength: 8 },
          { from: "part_a_mean", to: "part_b_new_mean", type: "enables", strength: 8 },
          { from: "part_a_range", to: "part_b_new_range", type: "enables", strength: 8 },
          { from: "part_b_new_mean", to: "part_b_setup_equation", type: "enables", strength: 9 },
          { from: "part_b_new_range", to: "part_b_range_condition", type: "enables", strength: 8 },
          { from: "part_b_setup_equation", to: "part_b_solve", type: "leads to", strength: 9 },
          { from: "part_b_range_condition", to: "part_b_solve", type: "enables", strength: 8 },
          { from: "part_b_solve", to: "part_b_final_weights", type: "leads to", strength: 9 },
          { from: "part_a_mean", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_a_median", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_a_range", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_b_final_weights", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  geometry: [
    {
      id: 'hkdse2015_geometry_01',
      problem: "In Figure 2, $ABCD$ is a square. $E$ and $F$ are points on $BC$ and $CD$ respectively such that $AE = BF$. $AE$ and $BF$ intersect at $G$. (a) Prove that $\\triangle ABE \\cong \\triangle BCF$. (b) Is $\\triangle BGE$ a right-angled triangle? Explain your answer. (c) If $CF = 15$ cm and $EG = 9$ cm, find $BG$.",
      problemType: "geometry_congruence",
      difficulty: "intermediate",
      description: "Square geometry with congruent triangles",
      graphData: {
        nodes: [
          {
            id: "square_properties",
            name: "Square Properties",
            type: "concepts",
            description: "ABCD is a square with given conditions",
            value: "ABCD is square, E on BC, F on CD, AE = BF",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_congruence",
            name: "Part (a): Congruence",
            type: "steps",
            description: "Prove △ABE ≅ △BCF",
            value: "AB = BC (square sides), AE = BF (given), ∠ABE = ∠BCF = 90°",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_rhs_congruence",
            name: "Part (a): RHS Congruence",
            type: "steps",
            description: "Use RHS congruence criterion",
            value: "Right angle, hypotenuse, side → △ABE ≅ △BCF",
            importance: 9,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_b_angle_analysis",
            name: "Part (b): Angle Analysis",
            type: "steps",
            description: "Analyze △BGE",
            value: "∠BGE = ∠AGF (vertically opposite), ∠AGF = 90°",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_b_conclusion",
            name: "Part (b): Conclusion",
            type: "steps",
            description: "Is △BGE right-angled?",
            value: "Yes, ∠BGE = 90°",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_c_given_values",
            name: "Part (c): Given Values",
            type: "concepts",
            description: "Use given measurements",
            value: "CF = 15 cm, EG = 9 cm",
            importance: 8,
            x: -200, y: 100, z: 0
          },
          {
            id: "part_c_find_be",
            name: "Part (c): Find BE",
            type: "steps",
            description: "Find BE using congruence",
            value: "BE = CF = 15 cm",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_c_find_bg",
            name: "Part (c): Find BG",
            type: "steps",
            description: "Use Pythagoras' theorem",
            value: "BG² = BE² - EG² = 15² - 9² = 225 - 81 = 144",
            importance: 9,
            x: 200, y: 100, z: 0
          },
          {
            id: "part_c_final_bg",
            name: "Part (c): Final BG",
            type: "steps",
            description: "Calculate BG",
            value: "BG = √144 = 12 cm",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "All required answers",
            value: "(a) Proven by RHS (b) Yes (c) 12 cm",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "square_properties", to: "part_a_congruence", type: "enables", strength: 9 },
          { from: "part_a_congruence", to: "part_a_rhs_congruence", type: "leads to", strength: 9 },
          { from: "part_a_rhs_congruence", to: "part_b_angle_analysis", type: "enables", strength: 8 },
          { from: "part_b_angle_analysis", to: "part_b_conclusion", type: "leads to", strength: 8 },
          { from: "part_a_rhs_congruence", to: "part_c_find_be", type: "enables", strength: 8 },
          { from: "part_c_given_values", to: "part_c_find_be", type: "enables", strength: 8 },
          { from: "part_c_find_be", to: "part_c_find_bg", type: "enables", strength: 9 },
          { from: "part_c_find_bg", to: "part_c_final_bg", type: "leads to", strength: 9 },
          { from: "part_a_rhs_congruence", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_conclusion", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_c_final_bg", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  circle_geometry_advanced: [
    {
      id: 'hkdse2015_circle_advanced_01',
      problem: "The coordinates of points $P$ and $Q$ are $(4, -1)$ and $(-14, 23)$ respectively. (a) Let $L$ be the perpendicular bisector of $PQ$. (i) Find the equation of $L$. (ii) Suppose $G$ is a point on $L$. Let the $x$-coordinate of $G$ be $h$. Let $C$ be a circle with center $G$ and passing through $P$ and $Q$. Prove that the equation of $C$ is $2x^2 + 2y^2 - 4hx - (3h + 59)y + 13h - 93 = 0$. (b) The coordinates of point $R$ are $(26, 43)$. Using part (a)(ii), or otherwise, find the diameter of the circle passing through $P$, $Q$ and $R$.",
      problemType: "circle_geometry_coordinate",
      difficulty: "harder",
      description: "Advanced circle geometry with coordinate geometry",
      graphData: {
        nodes: [
          {
            id: "given_points",
            name: "Given Points",
            type: "concepts",
            description: "Points P and Q coordinates",
            value: "P(4, -1), Q(-14, 23)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_midpoint",
            name: "Part (a): Midpoint",
            type: "steps",
            description: "Find midpoint of PQ",
            value: "Midpoint = ((4-14)/2, (-1+23)/2) = (-5, 11)",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_slope_pq",
            name: "Part (a): Slope PQ",
            type: "steps",
            description: "Find slope of PQ",
            value: "Slope PQ = (23-(-1))/(-14-4) = 24/(-18) = -4/3",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_a_slope_perpendicular",
            name: "Part (a): Perpendicular Slope",
            type: "steps",
            description: "Find slope of perpendicular bisector",
            value: "Slope of L = 3/4 (negative reciprocal)",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_equation_l",
            name: "Part (a): Equation of L",
            type: "steps",
            description: "Find equation of perpendicular bisector",
            value: "y - 11 = (3/4)(x - (-5)) → y = (3/4)x + 59/4",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_a_ii_circle_equation",
            name: "Part (a)(ii): Circle Equation",
            type: "steps",
            description: "Prove the given circle equation",
            value: "Use distance formula and expand",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_point_r",
            name: "Part (b): Point R",
            type: "concepts",
            description: "Add point R to the problem",
            value: "R(26, 43)",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_find_center",
            name: "Part (b): Find Center",
            type: "steps",
            description: "Find center of circle through P, Q, R",
            value: "Solve system of equations",
            importance: 8,
            x: 0, y: 250, z: 0
          },
          {
            id: "part_b_find_radius",
            name: "Part (b): Find Radius",
            type: "steps",
            description: "Calculate radius",
            value: "Use distance from center to any point",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_b_diameter",
            name: "Part (b): Diameter",
            type: "steps",
            description: "Calculate diameter",
            value: "Diameter = 2 × radius",
            importance: 8,
            x: 0, y: 350, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Equation and diameter",
            value: "(a)(i) y = (3/4)x + 59/4 (a)(ii) Proven (b) Diameter = calculated value",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "given_points", to: "part_a_midpoint", type: "enables", strength: 8 },
          { from: "given_points", to: "part_a_slope_pq", type: "enables", strength: 8 },
          { from: "part_a_slope_pq", to: "part_a_slope_perpendicular", type: "enables", strength: 8 },
          { from: "part_a_midpoint", to: "part_a_equation_l", type: "enables", strength: 9 },
          { from: "part_a_slope_perpendicular", to: "part_a_equation_l", type: "enables", strength: 9 },
          { from: "part_a_equation_l", to: "part_a_ii_circle_equation", type: "enables", strength: 9 },
          { from: "part_a_ii_circle_equation", to: "part_b_find_center", type: "enables", strength: 8 },
          { from: "part_b_point_r", to: "part_b_find_center", type: "enables", strength: 8 },
          { from: "part_b_find_center", to: "part_b_find_radius", type: "enables", strength: 8 },
          { from: "part_b_find_radius", to: "part_b_diameter", type: "leads to", strength: 8 },
          { from: "part_a_equation_l", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_a_ii_circle_equation", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_diameter", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  statistics_advanced: [
    {
      id: 'hkdse2015_statistics_advanced_01',
      problem: "The table below shows the mean and standard deviation of the scores of a group of students in Mathematics and Science examinations. The standard score of Ka Wah in the Mathematics examination is $-0.5$. (a) Find Ka Wah's score in the Mathematics examination. (b) Assume that the scores in each examination are normally distributed. Ka Wah scored $49$ marks in the Science examination. He claims that relative to other students, his performance in the Science examination is better than that in the Mathematics examination. Is this claim correct? Explain your answer.",
      problemType: "statistics_standard_score",
      difficulty: "intermediate",
      description: "Standard scores and normal distribution",
      graphData: {
        nodes: [
          {
            id: "exam_data",
            name: "Examination Data",
            type: "concepts",
            description: "Mean and standard deviation for each subject",
            value: "Math: Mean = 66, SD = 12; Science: Mean = 52, SD = 10",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "standard_score_formula",
            name: "Standard Score Formula",
            type: "formulas",
            description: "z = (x - μ)/σ",
            value: "z = (x - μ)/σ",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "part_a_ka_wah_math",
            name: "Part (a): Ka Wah Math",
            type: "steps",
            description: "Find Ka Wah's math score",
            value: "-0.5 = (x - 66)/12 → x = 66 - 6 = 60",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "part_b_ka_wah_science",
            name: "Part (b): Ka Wah Science",
            type: "steps",
            description: "Find Ka Wah's science standard score",
            value: "z = (49 - 52)/10 = -0.3",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_b_comparison",
            name: "Part (b): Comparison",
            type: "steps",
            description: "Compare standard scores",
            value: "Math: z = -0.5, Science: z = -0.3",
            importance: 8,
            x: 0, y: 50, z: 0
          },
          {
            id: "part_b_conclusion",
            name: "Part (b): Conclusion",
            type: "steps",
            description: "Is the claim correct?",
            value: "-0.3 > -0.5, so Science performance is better",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Math score and claim verification",
            value: "(a) 60 marks (b) Yes, claim is correct",
            importance: 10,
            x: 0, y: 150, z: 0
          }
        ],
        links: [
          { from: "exam_data", to: "standard_score_formula", type: "enables", strength: 9 },
          { from: "standard_score_formula", to: "part_a_ka_wah_math", type: "enables", strength: 9 },
          { from: "part_a_ka_wah_math", to: "part_b_ka_wah_science", type: "enables", strength: 8 },
          { from: "part_b_ka_wah_science", to: "part_b_comparison", type: "enables", strength: 8 },
          { from: "part_b_comparison", to: "part_b_conclusion", type: "leads to", strength: 9 },
          { from: "part_a_ka_wah_math", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_conclusion", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ]
}; 